/**
 * Shared HTTPS-only external-link validator for the competitive-intel (CI)
 * corpus.
 *
 * CI is the FIRST corpus whose results / citations point at an EXTERNAL
 * href (a competitor's own product page or press release) rather than an
 * in-app viewer route. Every place that can turn a stored/streamed CI URL
 * into a real `<a>` / `window.open` target — search-result rows
 * (`CiResults`), CEPI Sources chips (`CitationChip`), and the CEPI
 * citation-click hosts (`SearchPage`, `DrugDetailPage`) — MUST gate through
 * this one function so the contract can't drift between call sites.
 *
 * Deliberately conservative: only ever returns a normalized `https://` URL
 * string, or `null`. Malformed input, non-HTTP(S) schemes (`javascript:`,
 * `data:`, `file:`, …), protocol-relative URLs (no explicit scheme), and
 * plain `http://` (no TLS) all resolve to `null` so a bad/legacy value can
 * never become a clickable link.
 */
export function safeCompetitiveIntelUrl(
  url: string | null | undefined,
): string | null {
  if (!url) return null;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:') return null;
  return parsed.toString();
}

export default safeCompetitiveIntelUrl;
